"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeMtaDeclineText = void 0;
var React = require("react");
var HomeMtaDeclineText = /** @class */ (function () {
    function HomeMtaDeclineText() {
        // TODO: FAL-31708 probably number of days needs to be dynamic based on policy expiry date
        var futureWording = "we’ll need to cancel your policy with effect from seven days.";
        var prematureCancellationWording = "You can choose to cancel the policy yourself before then, to do this please email digitalhelp@allianz.co.uk.";
        var yearBuiltText = React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Thanks for telling us about this change. Unfortunately, we don\u2019t cover properties built in this year ",
                futureWording),
            React.createElement("p", null, prematureCancellationWording));
        var addressText = React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Thanks for telling us about your change of address. Unfortunately, we can\u2019t offer cover for this property ",
                futureWording),
            React.createElement("p", null, prematureCancellationWording));
        var propertyTypeText = React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Thanks for telling us about this change. Unfortunately, we don\u2019t cover this type of property ",
                futureWording),
            React.createElement("p", null, prematureCancellationWording));
        var bedroomsText = React.createElement("p", null,
            "Thanks for telling us about this change. Unfortunately, we don\u2019t cover properties with this number of bedrooms and ",
            futureWording);
        var bathroomsText = React.createElement("p", null,
            "Thanks for telling us about this change. Unfortunately, we don\u2019t cover properties with this number of bathrooms and ",
            futureWording);
        var buildingWorksText = React.createElement("p", null,
            "Thanks for letting us know about your building works. Unfortunately, this change of circumstances means ",
            futureWording);
        var situationText = React.createElement("p", null,
            "Thanks for letting us know your situation. Unfortunately, this change of circumstances means ",
            futureWording);
        var constructionText = React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Thanks for telling us about the change in the construction of your property. Unfortunately, this change means ",
                futureWording),
            React.createElement("p", null, prematureCancellationWording));
        var subsidenceText = React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Thanks for telling us about the subsidence, heave or landslip that occurred at your property. Unfortunately, this change means ",
                futureWording),
            React.createElement("p", null, prematureCancellationWording));
        var floodingText = React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Thanks for telling us about the flooding at your property. Unfortunately, this change means ",
                futureWording),
            React.createElement("p", null, prematureCancellationWording));
        var underpinningText = React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Thanks for telling us about the underpinning at your property. Unfortunately, this change means ",
                futureWording),
            React.createElement("p", null, prematureCancellationWording));
        var coverText = React.createElement("p", null,
            "Thanks for telling us about your change in circumstances. Unfortunately, we don\u2019t offer this type of cover and ",
            futureWording);
        var adultsText = React.createElement("p", null,
            "Thanks for telling us about the change in the number of adults living in your property. Unfortunately, this change means ",
            futureWording);
        var peopleText = React.createElement("p", null,
            "Thanks for telling us about the change in the number of people living in your property. Unfortunately, this change means ",
            futureWording);
        var circumstanceText = React.createElement("p", null,
            "Thanks for telling us about the change in circumstances. Unfortunately, this change means ",
            futureWording);
        var ownershipText = React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Thanks for telling us about the change in ownership of your property. Unfortunately, this change means ",
                futureWording),
            React.createElement("p", null, prematureCancellationWording));
        var listingText = React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Thanks for telling us about the change in the status of your property. Unfortunately, this change means ",
                futureWording),
            React.createElement("p", null, prematureCancellationWording));
        var phBirth = React.createElement("p", null,
            "Thanks for telling us about the change in your date of birth. Unfortunately, this change means ",
            futureWording);
        var jphBirth = React.createElement("p", null,
            "Thanks for telling us about the change in the joint policyholder\u2019s date of birth. Unfortunately, this change means ",
            futureWording);
        var claimsText = React.createElement("p", null,
            "Thanks for telling us about the change in your claims history. Unfortunately, this change means ",
            futureWording);
        var convictionText = React.createElement("p", null,
            "Thanks for telling us about the conviction for someone at your property. Unfortunately, this change means ",
            futureWording);
        var genericText = React.createElement("p", null,
            "Unfortunately, this change means ",
            futureWording);
        var phOccupation = React.createElement("p", null,
            "Thanks for telling us about your change of occupation. Unfortunately, this change means ",
            futureWording);
        var jphOccupation = React.createElement("p", null,
            "Thanks for telling us about the joint policyholder\u2019s change of occupation. Unfortunately, this change means ",
            futureWording);
        var levelText = React.createElement("p", null,
            "Unfortunately, we don\u2019t offer the level of cover you\u2019ve requested and ",
            futureWording);
        var itemsText = React.createElement("p", null,
            "Unfortunately, we don\u2019t offer cover for these types of items and ",
            futureWording);
        var claimsParagraph = React.createElement("p", null, "Please note that claims connected to this change will not be covered in this time.");
        var itemsParagraph = React.createElement("p", null, "Please note that claims for the additional item(s) will not be covered in this time. ");
        var unoccupancyParagraph = React.createElement("p", null, "Please note if your home\u2019s been unoccupied for more than 60 consecutive days, you won\u2019t be covered for escape of water or oil, theft or attempted theft, vandalism, accidental damage or contents in the garden.");
        this.underwritingResultCustomerWordings = [
            {
                key: "UWH001",
                value: phBirth
            },
            {
                key: "UWH002",
                value: jphBirth
            },
            {
                key: "UWH003",
                value: phOccupation
            },
            {
                key: "UWH004",
                value: jphOccupation
            },
            {
                key: "UWH005",
                value: situationText
            },
            {
                key: "UWH006",
                value: convictionText
            },
            {
                key: "UWH007",
                value: yearBuiltText
            },
            {
                key: "UWH008",
                value: yearBuiltText
            },
            {
                key: "UWH009",
                value: bedroomsText
            },
            {
                key: "UWH010",
                value: bedroomsText
            },
            {
                key: "UWH011",
                value: ownershipText
            },
            {
                key: "UWH012",
                value: ownershipText
            },
            {
                key: "UW013",
                value: listingText
            },
            {
                key: "UWH014",
                value: buildingWorksText
            },
            {
                key: "UWH015",
                value: situationText
            },
            {
                key: "UWH016",
                value: subsidenceText
            },
            {
                key: "UWH017",
                value: floodingText
            },
            {
                key: "UWH018",
                value: coverText,
                extraContent: claimsParagraph
            },
            {
                key: "UWH019",
                value: coverText,
                extraContent: claimsParagraph
            },
            {
                key: "UWH020",
                value: coverText,
                extraContent: claimsParagraph
            },
            {
                key: "UWH021",
                value: coverText,
                extraContent: claimsParagraph
            },
            {
                key: "UWH022",
                value: circumstanceText
            },
            {
                key: "UWH031",
                value: levelText,
                extraContent: itemsParagraph
            },
            {
                key: "UWH032",
                value: itemsText,
                extraContent: itemsParagraph
            },
            {
                key: "UWH033",
                value: levelText,
                extraContent: itemsParagraph
            },
            {
                key: "UWH036",
                value: levelText,
                extraContent: itemsParagraph
            },
            {
                key: "UWH037",
                value: itemsText,
                extraContent: itemsParagraph
            },
            {
                key: "UWH039",
                value: levelText,
                extraContent: itemsParagraph
            },
            {
                key: "UWH040",
                value: claimsText
            },
            {
                key: "UWH041",
                value: constructionText
            },
            {
                key: "UWH042",
                value: constructionText
            },
            {
                key: "UWH044",
                value: propertyTypeText
            },
            {
                key: "UWH045",
                value: propertyTypeText
            },
            {
                key: "UWH048",
                value: bathroomsText
            },
            {
                key: "UWH049",
                value: circumstanceText,
                extraContent: unoccupancyParagraph
            },
            {
                key: "UWH051",
                value: adultsText,
                extraContent: claimsParagraph
            },
            {
                key: "UWH052",
                value: peopleText,
                extraContent: claimsParagraph
            },
            {
                key: "UWH053",
                value: situationText
            },
            {
                key: "UWH054",
                value: underpinningText
            },
            {
                key: "UWH055",
                value: genericText,
            },
            {
                key: "UWH056",
                value: addressText
            },
            {
                key: "UWH057",
                value: genericText
            },
            {
                key: "UWH1001",
                value: genericText
            },
            {
                key: "UWH1002",
                value: genericText
            },
            {
                key: "UWH1003",
                value: genericText
            },
            {
                key: "UWH1004",
                value: genericText
            },
            {
                key: "UWH1005",
                value: genericText
            },
            {
                key: "UWH1006",
                value: genericText
            },
            {
                key: "UWH1007",
                value: genericText
            },
            {
                key: "UWH1008",
                value: genericText
            }
        ];
    }
    return HomeMtaDeclineText;
}());
exports.HomeMtaDeclineText = HomeMtaDeclineText;
//# sourceMappingURL=HomeMtaDeclineText.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/declineTextOutputWidget/HomeMtaDeclineText.js
// module id = 3669
// module chunks = 0